import { useState } from "react";

const starIcon = (
  <svg width="18" height="16" viewBox="0 0 18 16" className="fill-current">
    <path d="M9.09815 0.361679L11.1054 6.06601H17.601L12.3459 9.59149L14.3532 15.2958L9.09815 11.7703L3.84309 15.2958L5.85035 9.59149L0.595291 6.06601H7.0909L9.09815 0.361679Z" />
  </svg>
);

const SingleTestimonial = ({ testimonial }) => {
  const { star, name, image, content, designation } = testimonial;
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  let ratingIcons = [];
  for (let index = 0; index < star; index++) {
    ratingIcons.push(
      <span key={index} className="text-yellow">
        {starIcon}
      </span>
    );
  }

  return (
    <div className="w-full">
      <div
        className="wow fadeInUp rounded-md bg-white p-8 shadow-one dark:bg-[#1D2144] lg:px-5 xl:px-8"
        data-wow-delay=".1s"
      >
        <div className="mb-5 flex items-center space-x-1">{ratingIcons}</div>
        <p className="mb-4 border-b border-body-color border-opacity-10 pb-4 text-base leading-relaxed text-body-color dark:border-white dark:border-opacity-10 dark:text-white">
          {expanded
            ? content
            : `${content.slice(0, 200)}${content.length > 200 ? "..." : ""}`}
          {content.length > 200 && (
            <button
              onClick={toggleExpand}
              className={`text-blue-500 ${expanded ? "block mt-4" : "inline ml-2"}`}
            >
              {expanded ? '\nView Less' : 'View More'}
            </button>
          )}
        </p>
        <div className="flex items-center">
          <div className="relative mr-4 h-[50px] w-full max-w-[50px] overflow-hidden rounded-full">
            <img src={image} alt={name} />
          </div>
          <div className="w-full">
            <h5 className="mb-1 text-lg font-semibold text-dark dark:text-white lg:text-base xl:text-lg">
              {name}
            </h5>
            {/* <p className="text-sm text-body-color">{designation}</p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleTestimonial;
